import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Zap, Heart, Brain } from 'lucide-react';
const services = [{
  icon: Sparkles,
  title: 'NAD+ IV Therapy',
  description: 'Direct intravenous infusion for maximum bioavailability and immediate cellular support.',
  duration: '60-90 minutes',
  benefits: ['Rapid energy boost', 'Enhanced mental clarity', 'Cellular rejuvenation']
}, {
  icon: Zap,
  title: 'Cellular Optimization',
  description: 'Comprehensive protocol combining NAD+ with targeted nutrients for complete cellular health.',
  duration: '90-120 minutes',
  benefits: ['Mitochondrial support', 'DNA repair activation', 'Metabolic enhancement']
}, {
  icon: Heart,
  title: 'Longevity Protocol',
  description: 'Our signature treatment designed for sustained vitality and healthy aging.',
  duration: '120 minutes',
  benefits: ['Anti-aging support', 'Cognitive enhancement', 'Sustained energy']
}, {
  icon: Brain,
  title: 'Cognitive Enhancement',
  description: 'Specialized NAD+ formulation optimized for mental performance and neuroprotection.',
  duration: '75 minutes',
  benefits: ['Focus & clarity', 'Memory support', 'Neuroprotection']
}];
export function Services() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white" data-id="element-342">
      {/* Hero Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-343">
        <div className="max-w-4xl mx-auto text-center" data-id="element-344">
          <motion.p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-345">
            Our Services
          </motion.p>
          <motion.h1 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-346">
            Precision Treatments
          </motion.h1>
          <motion.p className="text-lg md:text-xl text-zinc-600 leading-relaxed max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-347">
            Tailored NAD+ protocols designed to optimize your cellular health
            and unlock your body's full potential.
          </motion.p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="px-6 py-32 md:py-40 bg-white" data-id="element-348">
        <div className="max-w-7xl mx-auto" data-id="element-349">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-350">
            {services.map((service, index) => {
            const Icon = service.icon;
            return <div key={index} className="border border-zinc-200 p-8 md:p-12" data-id="element-351">
                  <div className="mb-6 inline-flex p-4 bg-zinc-950 text-white rounded-full" data-id="element-352">
                    <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-353" />
                  </div>
                  <h3 className="text-3xl font-serif mb-4 text-zinc-950" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-354">
                    {service.title}
                  </h3>
                  <p className="text-zinc-600 leading-relaxed mb-6" data-id="element-355">
                    {service.description}
                  </p>
                  <div className="mb-6" data-id="element-356">
                    <p className="text-sm tracking-[0.2em] uppercase text-zinc-500 mb-2" data-id="element-357">
                      Duration
                    </p>
                    <p className="text-zinc-900" data-id="element-358">{service.duration}</p>
                  </div>
                  <div data-id="element-359">
                    <p className="text-sm tracking-[0.2em] uppercase text-zinc-500 mb-3" data-id="element-360">
                      Key Benefits
                    </p>
                    <ul className="space-y-2" data-id="element-361">
                      {service.benefits.map((benefit, i) => <li key={i} className="text-zinc-600 flex items-center" data-id="element-362">
                          <span className="w-1.5 h-1.5 bg-zinc-950 rounded-full mr-3" data-id="element-363"></span>
                          {benefit}
                        </li>)}
                    </ul>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-364">
        <div className="max-w-3xl mx-auto text-center" data-id="element-365">
          <h2 className="text-4xl md:text-5xl font-serif mb-8" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-366">
            Begin Your Journey
          </h2>
          <p className="text-lg text-zinc-600 mb-12 max-w-xl mx-auto" data-id="element-367">
            Schedule a consultation to discover which protocol is right for you.
          </p>
          <button className="px-12 py-4 bg-zinc-950 text-white text-sm tracking-[0.2em] uppercase font-medium hover:bg-zinc-800 transition-colors duration-300" data-id="element-368">
            Book Consultation
          </button>
        </div>
      </section>
    </motion.div>;
}